import { render, staticRenderFns } from "./CustomerProfileGeneral.vue?vue&type=template&id=09b257c2&scoped=true&"
import script from "./CustomerProfileGeneral.vue?vue&type=script&lang=ts&"
export * from "./CustomerProfileGeneral.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerProfileGeneral.vue?vue&type=style&index=0&id=09b257c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b257c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VListItem,VListItemAction,VListItemContent,VRow})
